import { useContext } from 'react';
import { LanguageContext } from './LanguageContext';

export function useAppLanguage() {
  return useContext(LanguageContext);
}
